var styleDataHash = "158a0a69";
const injectCss = () => {
  var css = `.WNHPS{display:block}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var settings_panel_discard_modal_default = {
  "modal_container": "WNHPS"
};
export {
  settings_panel_discard_modal_default as default,
  injectCss
};
//# sourceMappingURL=settings-panel-discard-modal-scss.js.map
